module.exports = __webpack_public_path__ + "static/media/Rules.904e4fcb.svg";